"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlRevokeRoleDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_query_1 = require("@tanstack/react-query");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_dialog_confirmation_1 = require("@dzambalaorg/mui-dialog-confirmation");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_api_firebase_1 = require("@dzambalaorg/provider-api-firebase");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const revokeRole_json_1 = __importDefault(require("@framework/abis/json/AccessControlFacet/revokeRole.json"));
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const AccessControlRevokeRoleDialog = (props) => {
    const { data, open, onCancel, ...rest } = props;
    const { address: account = "" } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const api = (0, provider_api_firebase_1.useApi)();
    const { data: rows = [], isLoading } = (0, react_query_1.useQuery)({
        queryKey: [`/access-control/${data.address}`],
        queryFn: async () => {
            const response = await api.fetchJson({
                url: `/access-control/${data.address}`,
                method: "GET",
            });
            return response.filter(row => row.account !== account.toLowerCase());
        },
        enabled: open,
    });
    const { execute: metaRevokeRole } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: data.address,
            abi: revokeRole_json_1.default,
            functionName: "revokeRole",
            args: [
                Object.values(types_1.AccessControlRoleHash)[Object.keys(types_1.AccessControlRoleHash).indexOf(values.role)],
                values.account,
            ],
        });
    });
    const handleRevoke = (values) => {
        return async () => {
            await metaRevokeRole(values);
            onCancel();
        };
    };
    return ((0, jsx_runtime_1.jsx)(mui_dialog_confirmation_1.ConfirmationDialog, { message: "dialogs.revokeRole", "data-testid": "AccessControlRevokeRoleDialog", open: open, onCancel: onCancel, ...rest, children: (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: rows.length, isLoading: isLoading, children: rows.map(access => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemText, { children: [access.account_contract?.title || access.account, (0, jsx_runtime_1.jsx)("br", {}), access.role] }), (0, jsx_runtime_1.jsx)(styled_1.ListActions, { children: (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleRevoke(access), message: "dialogs.revokeRole", icon: icons_material_1.Delete }) })] }, access.id))) }) }) }));
};
exports.AccessControlRevokeRoleDialog = AccessControlRevokeRoleDialog;
//# sourceMappingURL=index.js.map